// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-colon-space-after */
:root {
  /* these colors are specific to THERMS UI */
  /* Background --- */
  --color-background: #fff;

  /* Border --- */
  --color-border: #d4dadd;

  /* Surface --- */
  --color-surface-subtle: #f0f2f2;
  --color-surface: #e8ebed;
  --color-surface-strong: #dee1e3;

  /* Text --- */
  --color-text-subtle: #00111a73;
  --color-text: #00111abf;
  --color-text-strong: #00111af2;
  --color-text-semantic: #fff;

  /* Semantic */
  --color-main-dark: #010c1e;
  --color-main: #001c3f;
  --color-main-light: #00327e;
  --color-main-faded: rgba(0, 55, 134, 0.4);

  --color-neutral-dark: #819498;
  --color-neutral: #8fa0a3;
  --color-neutral-light: #c6cfd2;
  --color-neutral-faded: #8fa0a366;

  --color-positive-dark: #196645;
  --color-positive: #2eb87c;
  --color-positive-light: #70dbad;
  --color-positive-faded: #2eb87c66;

  --color-caution-dark: #bd7f00;
  --color-caution: #f9b21f;
  --color-caution-light: #ffc857;
  --color-caution-faded: #f9b21f66;

  --color-critical-dark: #b83314;
  --color-critical: #e5401a;
  --color-critical-light: #ff8366;
  --color-critical-faded: #e5401a66;

  --color-info-dark: #1c9c9c;
  --color-info: #26d9d9;
  --color-info-light: #7de8e8;
  --color-info-faded: #26d9d966;

  /* Scrollbar */
  --color-scrollbar-track: #d4d9d9;
  --color-scrollbar-thumb: #afb3b3;
  --color-scrollbar-thumb-highlight: #bbbfbf;

  /* Input */
  --color-input-background: #ccd5d7;
}
`, "",{"version":3,"sources":["webpack://./src/colors-light.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,wBAAwB;;EAExB,eAAe;EACf,uBAAuB;;EAEvB,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,+BAA+B;;EAE/B,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;;EAE3B,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;;EAEzC,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;;EAEhC,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;;EAEjC,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;;EAEhC,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;;EAEjC,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;;EAE7B,cAAc;EACd,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;;EAE1C,UAAU;EACV,iCAAiC;AACnC","sourcesContent":["/* stylelint-disable declaration-colon-space-after */\n:root {\n  /* these colors are specific to THERMS UI */\n  /* Background --- */\n  --color-background: #fff;\n\n  /* Border --- */\n  --color-border: #d4dadd;\n\n  /* Surface --- */\n  --color-surface-subtle: #f0f2f2;\n  --color-surface: #e8ebed;\n  --color-surface-strong: #dee1e3;\n\n  /* Text --- */\n  --color-text-subtle: #00111a73;\n  --color-text: #00111abf;\n  --color-text-strong: #00111af2;\n  --color-text-semantic: #fff;\n\n  /* Semantic */\n  --color-main-dark: #010c1e;\n  --color-main: #001c3f;\n  --color-main-light: #00327e;\n  --color-main-faded: rgba(0, 55, 134, 0.4);\n\n  --color-neutral-dark: #819498;\n  --color-neutral: #8fa0a3;\n  --color-neutral-light: #c6cfd2;\n  --color-neutral-faded: #8fa0a366;\n\n  --color-positive-dark: #196645;\n  --color-positive: #2eb87c;\n  --color-positive-light: #70dbad;\n  --color-positive-faded: #2eb87c66;\n\n  --color-caution-dark: #bd7f00;\n  --color-caution: #f9b21f;\n  --color-caution-light: #ffc857;\n  --color-caution-faded: #f9b21f66;\n\n  --color-critical-dark: #b83314;\n  --color-critical: #e5401a;\n  --color-critical-light: #ff8366;\n  --color-critical-faded: #e5401a66;\n\n  --color-info-dark: #1c9c9c;\n  --color-info: #26d9d9;\n  --color-info-light: #7de8e8;\n  --color-info-faded: #26d9d966;\n\n  /* Scrollbar */\n  --color-scrollbar-track: #d4d9d9;\n  --color-scrollbar-thumb: #afb3b3;\n  --color-scrollbar-thumb-highlight: #bbbfbf;\n\n  /* Input */\n  --color-input-background: #ccd5d7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
